import { DateTime } from "luxon"

export const formatActivityDate = (
  start_date: string | null | undefined,
  useLocalTimezone: boolean,
  timezone: string | null,
): string => {
  const emptyState = "Coming soon"
  if (!start_date) return emptyState

  const formattedDateTime = useLocalTimezone
    ? DateTime.fromISO(start_date)
    : DateTime.fromISO(start_date, { zone: timezone })

  if (!formattedDateTime) return emptyState

  return formattedDateTime.toFormat("ccc, LLL d • h:mm a ZZZZ")
}
